export default __webpack_public_path__ + "static/ProServices-Photo2-8f82b7879f09c9d681098e22ab1ea902.png";